(function () {
  'use strict';
  var MOBILE_QUERY = '(max-width: 719px)';

  function init() {
    var galleryColumn = document.querySelector('.product-gallery-column');
    if (!galleryColumn) return;

    var pieces = [
      document.querySelector('.product-gallery__breadcrumbs'),
      document.querySelector('.product-vendor-rating--price-row'),
      document.querySelector('.product-title'),
      document.querySelector('.product-vendor-row'),
      document.querySelector('.product-block--price'),
      document.querySelector('.product-block--pay_after'),
    ]
      .filter(Boolean)
      .map(function (el) {
        return { el: el, parent: el.parentNode, next: el.nextSibling };
      });
    if (!pieces.length) return;

    var mobileHeader = document.createElement('div');
    mobileHeader.className = 'product-mobile-header';

    var mq = window.matchMedia(MOBILE_QUERY);

    function apply() {
      if (mq.matches) {
        if (!mobileHeader.parentNode) {
          galleryColumn.parentNode.insertBefore(mobileHeader, galleryColumn);
        }
        pieces.forEach(function (p) {
          if (p.el.parentNode !== mobileHeader) mobileHeader.appendChild(p.el);
        });
      } else {
        pieces.forEach(function (p) {
          if (p.el.parentNode === mobileHeader) {
            p.parent.insertBefore(p.el, p.next);
          }
        });
        if (mobileHeader.parentNode) mobileHeader.parentNode.removeChild(mobileHeader);
      }
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function initAccordionAfterComplementary() {
    var complementarySection = document.querySelector('.product-complementary-section');
    var accordionList = document.querySelector('[data-pia-list]');
    if (!complementarySection || !accordionList) return;

    var originalParent = accordionList.parentNode;
    var originalNext = accordionList.nextSibling;

    var mq = window.matchMedia(MOBILE_QUERY);

    function apply() {
      if (mq.matches) {
        complementarySection.parentNode.insertBefore(accordionList, complementarySection.nextSibling);
      } else if (accordionList.parentNode !== originalParent) {
        originalParent.insertBefore(accordionList, originalNext);
      }
      /* Reveals the accordion only after it's actually in its correct
         position for the current viewport - CSS hides it by default
         on mobile (product-redesign.css) so a slow/deferred script
         execution can never flash it at its original desktop position
         before this runs, per explicit bug report (old position
         visible briefly on refresh, then jumping to the right spot). */
      accordionList.classList.add('product-mobile-reorder-ready');
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function initWishlistInRatingRow() {
    var wishlistBtn = document.querySelector('.product-favourite-link--vendor-row');
    var ratingRow = document.querySelector('.product-vendor-rating--price-row');
    if (!wishlistBtn || !ratingRow) return;

    /* Captures the button's real parent (.product-vendor-row itself,
       not wherever that row currently sits on the page) and its
       original next-sibling within it - vendor-row is separately
       moved as a whole unit between the mobile-header group and its
       normal position by init() above, so restoring the button back
       into vendor-row (rather than to some fixed page position) stays
       correct regardless of which position vendor-row is currently
       in, and regardless of the order these two functions run in. */
    var originalParent = wishlistBtn.parentNode;
    var originalNext = wishlistBtn.nextSibling;

    var mq = window.matchMedia(MOBILE_QUERY);

    function apply() {
      if (mq.matches) {
        if (wishlistBtn.parentNode !== ratingRow) ratingRow.appendChild(wishlistBtn);
      } else if (wishlistBtn.parentNode !== originalParent) {
        originalParent.insertBefore(wishlistBtn, originalNext);
      }
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function run() {
    /* pay-after now sits right after price structurally (block_order
       in templates/product.json), same as desktop - init()'s own
       pieces array above moves the two together into the mobile-
       header group, so no separate JS anchoring is needed here
       anymore (the old initPayAfterBelowPrice function this replaced
       is gone). */
    init();
    initAccordionAfterComplementary();
    initWishlistInRatingRow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
